<template>
  <b-modal :id="id" hide-header hide-footer v-on:hide="hideEvent" :centered="centered">
    <template #default="{ ok }">
      <b-row class="error-message" no-gutters>
        {{ msg }}
      </b-row>
      <b-row class="error-footer" no-gutters>
        <confirm class="col-5" label="OK" v-on:confirm="clickedOK(ok)" />
      </b-row>
    </template>
  </b-modal>
</template>

<style scoped>
.error-message {
  font-size: 16px;
  font-weight: bold;
  white-space: pre-line;
}

.error-footer {
  margin-top: 50px;
  display: flex;
  flex-direction: row-reverse;
}
</style>

<script lang="ts">
import { defineComponent, getCurrentInstance, onMounted } from "vue";
import type Vue from "vue";
import Confirm from "./button/Confirm.vue";

export default defineComponent({
  name: "error-modal",
  components: { Confirm },
  props: {
    id: { type: String, default: "", required: true },
    msg: { type: String, default: "", required: true },
    centered: { type: Boolean, default: true },
    // Storybook向け
    show: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    // $bvModal は BootstrapVue が生やす（Step 3 で composable 化予定）
    const vm = getCurrentInstance()?.proxy as Vue | undefined;

    // OK clicked
    const clickedOK = (okEvent: () => void): void => {
      emit("clickedOK");
      okEvent();
    };

    // モーダルが閉じた際の処理
    const hideEvent = (): void => {
      emit("hideModal");
    };

    onMounted(() => {
      if (props.show) {
        vm?.$bvModal.show(props.id);
      }
    });

    return { clickedOK, hideEvent };
  },
});
</script>
